import React from 'react';
import { cn } from '@/lib/utils';

export default function StatsCard({ 
  title, 
  value, 
  icon: Icon, 
  gradient = 'from-blue-500 to-blue-600',
  trend,
  trendUp 
}) {
  return (
    <div className={cn(
      "relative overflow-hidden rounded-2xl p-5 text-white shadow-lg",
      `bg-gradient-to-br ${gradient}`
    )}>
      <div className="absolute top-0 right-0 w-24 h-24 transform translate-x-6 -translate-y-6">
        <div className="w-full h-full rounded-full bg-white/10" />
      </div>
      <div className="relative">
        <div className="flex items-start justify-between">
          <div>
            <p className="text-sm font-medium text-white/80">{title}</p>
            <p className="text-3xl font-bold mt-1">{value}</p>
            {trend && (
              <p className={cn(
                "text-sm mt-2 font-medium",
                trendUp ? "text-green-200" : "text-red-200"
              )}>
                {trend}
              </p>
            )}
          </div>
          {Icon && (
            <div className="p-2 bg-white/20 rounded-xl">
              <Icon className="w-6 h-6" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}